import { useContext } from "react";
import Typography from "@common/components/Typography";
import { useTranslation } from "react-i18next";
import AdapterListView from "./AdapterListView";
import { ReducerContext } from "@pages/Configuration/DeviceCatalog/context";

const AdapterTabContent = () => {
  const { device, deviceAdapters } = useContext(ReducerContext);
  const { t } = useTranslation();

  return (
    <>
      <Typography sx={{ m: 2 }} size="medium">
        {`${device.manufacturer} ${device.model} - ${t("Adapters")} (${
          deviceAdapters?.length ?? 0
        })`}
      </Typography>
      <AdapterListView />
    </>
  );
};

export default AdapterTabContent;
